import React from "react";

import Button from "../../../../Components/Button";
import CommonModal from "../../../../Components/Modal";
import "./style.scss";

interface ToggleUserStatusModalProps {
  isOpen: boolean;
  toggle: () => void;
  userName: string;
  currentStatus: string;
  onConfirm: () => void;
  loading?: boolean;
}

const ToggleUserStatusModal: React.FC<ToggleUserStatusModalProps> = ({
  isOpen,
  toggle,
  userName,
  currentStatus,
  onConfirm,
  loading = false,
}) => {
  const isActive = currentStatus === "active";
  const action = isActive ? "deactivate" : "activate";
  const title = isActive ? "Deactivate User" : "Activate User";

  return (
    <CommonModal isOpen={isOpen} toggle={toggle} title={title} size="md">
      <div className="toggle-user-status-modal">
        <p className="confirmation-text">
          Are you sure you want to {action} <strong>{userName}</strong>?
        </p>

        <div className="modal-actions">
          <Button variant="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            loading={loading}
            variant={isActive ? "danger" : "primary"}
            onClick={onConfirm}
          >
            {isActive ? "Deactivate" : "Activate"}
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export default ToggleUserStatusModal;
